<template>
  <v-content>
    <transition :name="fade ? 'fade' : ''">
      <v-layout class="justify-center">
        <v-flex xs12 s12 md12 lg12>
          <v-sheet
            :style="{ 'background-color': backgroundColor }"
            class="mx-auto"
            max-width="100%"
          >
            <v-slide-group
              v-model="model"
              show-arrows
              center-active
              class="slide-group"
              style="height: 50px;"
            >
              <v-slide-item
                v-for="(category, i) in categorys"
                :key="i"
                v-slot:default="{ toggle }"
              >
                <v-btn
                  @click="toggle"
                  :dark="dark"
                  class="mx-1 my-2"
                  :style="
                    parseInt(category_id) === parseInt(category.id)
                      ? {
                          'background-color': checkBtnColor(category.id),
                          color: '#FFFFFF',
                          height: '40px',
                        }
                      : {
                          color: '#FFFFFF',
                          'background-color': '#9C9C9C',
                        }
                  "
                  height="40"
                  :color="colorBtn"
                  @click.native="onClickCategory(category)"
                >
                  <v-img
                    lazy-src=""
                    :width="category.id == 0 ? '20' : '35'"
                    :src="checkIcon(category.name_en)"
                  ></v-img>
                  <!-- <v-icon>{{ category.icon }}</v-icon> -->
                  <span class="ml-4"
                    >{{
                      switchLanguage === "th"
                        ? category.name_th
                        : category.name_en
                    }}
                  </span>
                  <span class="ml-3" style="color: #fff">
                    {{ category.portfolio_total }}
                  </span>
                </v-btn>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-flex>
      </v-layout>
    </transition>

    <loading
      loader="dots"
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-content>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";

export default {
  name: "SlideGroup",
  components: {
    Loading,
  },
  props: {
    onClickCategory: Function,
    category_id: String,
    backgroundColor: {
      type: String,
      default: "#F8F8F8",
    },
    page: {
      type: String,
    },
    colorBtn: {
      type: String,
      default: "#DFDFDF",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    loadingDialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fade: false,
    model: null,
    categorys: [
      {
        id: "0",
        name_th: "รวม",
        name_en: "All",
        icon: "subject",
        portfolio_total: "",
      },
    ],
    isLoading: false,
    fullPage: true,
  }),
  created() {
    this.getCategory();
  },

  computed: {
    ...mapState({
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },

  methods: {
    checkIcon(iconName) {
      switch (iconName) {
        case "Design":
          return require("../../assets/icons/whiteIcon/การออกแบบ@2x.png");
        case "Architecture":
          return require("../../assets/icons/whiteIcon/สถาปัตยกรรม@2x.png");
        case "Fashion":
          return require("../../assets/icons/whiteIcon/แฟชั่น@2x.png");
        case "Craft":
          return require("../../assets/icons/whiteIcon/งานฝีมือ@2x.png");
        case "Advertising":
          return require("../../assets/icons/whiteIcon/การโฆษณา@2x.png");
        case "Visual Arts":
          return require("../../assets/icons/whiteIcon/ทัศนศิลป์@2x.png");
        case "Food":
          return require("../../assets/icons/whiteIcon/อาหารไทย@2x.png");
        case "Cultural and Heritage Tourism":
          return require("../../assets/icons/whiteIcon/การท่องเที่ยวเชิงวัฒนธรรม@2x.png");
        case "Film":
          return require("../../assets/icons/whiteIcon/ภาพยนต์@2x.png");
        case "Publishing":
          return require("../../assets/icons/whiteIcon/การพิมพ์@2x.png");
        case "Software":
          return require("../../assets/icons/whiteIcon/ซอฟแวร์@2x.png");
        case "Music":
          return require("../../assets/icons/whiteIcon/ดนตรี@2x.png");
        case "Performing Arts":
          return require("../../assets/icons/whiteIcon/ศิลปะการแสดง@2x.png");
        case "Broadcasting":
          return require("../../assets/icons/whiteIcon/การแพร่ภาพและกระจายเสียง@2x.png");
        case "Thai Traditional Medicine":
          return require("../../assets/icons/whiteIcon/การแพทย์แผนไทย@2x.png");
        default:
          return require("../../assets/icons/whiteIcon/ทั้งหมด@2x.png");
      }
    },
    getCategory() {
      if (this.loadingDialog === false) {
        this.isLoading = true;
      }
      this.$store
        .dispatch("Categoty/getCategory")
        .then((res) => {
          this.categorys[0].portfolio_total = res.data.count_port_all;
          res.data.categories_list.forEach((data) => {
            this.categorys.push({
              id: data.id,
              name_th: data.name_th,
              name_en: data.name_en,
              icon: data.icon,
              portfolio_total: data.portfolio_total,
            });
          });

          this.fade = true;
          this.isLoading = false;
          this.model = this.categorys.findIndex((item) => {
            return item.id == this.getCateId();
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    checkBtnColor(cateId) {
      switch (cateId) {
        case "0":
          return "#ef3e2e";
        case "10":
          return "#74bf92";
        case "11":
          return "#ac9277";
        case "12":
          return "#c98074";
        case "1":
          return "#957722";
        case "9":
          return "#e19705";
        case "4":
          return "#4cc2d2";
        case "13":
          return "#e47645";
        case "115":
          return "#8a233d";
        case "5":
          return "#cd4646";
        case "7":
          return "#92b4cb";
        case "8":
          return "#9f939a";
        case "2":
          return "#733c90";
        case "3":
          return "#684c41";
        case "6":
          return "#3b5fa6";
        case "14":
          return "#28645e";
        default:
          return "#ef3e2e";
      }
    },
  },
};
</script>

<style lang="scss">
.color-toggle {
  span {
    color: #ffffff;
  }
}

button.mx-1.btn-slide.v-btn.v-btn--contained.theme--light.v-size--default {
  border-bottom-right-radius: unset !important;
  border-bottom-left-radius: unset !important;
}

.slide-group .v-slide-group__content {
  align-items: flex-end;
}

.btn-cate-active {
  background-color: #fd5246;
  color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
